module.exports = __webpack_public_path__ + "static/media/unavailable-icon.8e0dc8ae.svg";